import {
  AUTH,
  END_LOADING,
  LOGOUT,
  START_LOADING,
  UPDATE_USER_PROFILE,
  SET_RESOLVED_COMPANY,
  DB_INITIALIZING,
  DB_READY,
  MUST_CHANGE_PASSWORD,
  PASSWORD_CHANGED,
} from "../actions/constants";

const resolvedCompanyInit = (() => {
  try {
    const cached = localStorage.getItem("resolvedCompany");
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
})();

const authDataInit = (() => {
  try {
    const cached = localStorage.getItem("profile");
    return cached ? JSON.parse(cached) : null;
  } catch {
    return null;
  }
})();

const initialState = {
  authData: authDataInit,
  isLoading: false,
  resolvedCompany: resolvedCompanyInit,
  dbInitializing: false,
  mustChangePassword: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case AUTH:
      localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
      return { ...state, authData: action?.data };

    case LOGOUT: {
      // Remove all localStorage entries except company domain cache entries.
      // companyCache_* and resolvedCompany are harmless subdomain→companyId
      // mappings that allow the login page to function when the company
      // resolution service is temporarily unreachable.
      const PRESERVED = new Set(["resolvedCompany", "moduleConfig", "moduleConfig_ts"]);
      const toRemove = [];
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && !key.startsWith("companyCache_") && !PRESERVED.has(key)) {
          toRemove.push(key);
        }
      }
      toRemove.forEach((k) => localStorage.removeItem(k));
      return {
        ...state,
        authData: null,
        dbInitializing: false,
        mustChangePassword: false,
      };
    }

    case UPDATE_USER_PROFILE:
      localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
      return { ...state, authData: action?.data };

    case SET_RESOLVED_COMPANY:
      return { ...state, resolvedCompany: action.payload };

    case DB_INITIALIZING:
      return { ...state, dbInitializing: true };

    case DB_READY:
      return { ...state, dbInitializing: false };

    case MUST_CHANGE_PASSWORD:
      return { ...state, mustChangePassword: true };

    case PASSWORD_CHANGED:
      return { ...state, mustChangePassword: false };

    default:
      return state;
  }
};

export default authReducer;
